module.exports = __webpack_public_path__ + "static/img/screenshot-monitor-dashboard.2e80545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot-monitor-dashboard.png
// module id = 73Zv
// module chunks = 1